import { ChangeEvent, FunctionComponent, useCallback } from 'react';
import { Container, FormControl, FormHelperText, Grid, TextField } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import FortuneWheelTable from './fortune-wheel-table';

type FieldFortuneWheelProps = {
    error: boolean;
    setValue: (value: HallFortuneWheel) => void;
    value: HallFortuneWheel;
};

const FieldFortuneWheel: FunctionComponent<FieldFortuneWheelProps> = ({ error, setValue, value }) => {
    const onChangePeriod = useCallback((e: ChangeEvent<HTMLInputElement>) => {
        const newValue = e.target.value.trim();
        if (newValue.match(/^\d+$/)) {
            setValue({ ...value, period: +newValue * 60 });
        }
    }, [value, setValue]);
    const onChangeMinDeposit = useCallback((e: ChangeEvent<HTMLInputElement>) => {
        const newValue = e.target.value.trim();
        if (newValue.match(/^\d+$/)) {
            setValue({ ...value, minDeposit: +newValue });
        }
    }, [value, setValue]);
    const onChangeWager = useCallback((e: ChangeEvent<HTMLInputElement>) => {
        const newValue = e.target.value.trim();
        if (newValue.match(/^\d+$/)) {
            setValue({ ...value, wager: +newValue });
        }
    }, [value, setValue]);
    const onChangeSectors = useCallback((sectors: HallFortuneWheelSector[]) => setValue({ ...value, sectors: sectors }), [value, setValue]);
    const [t] = useTranslation();
    return <Container>
        <h2>{t("ru.halls.wager.fortune_wheel.title")}</h2>
        <Grid item xs={3} sm={12}>
            <FormControl error={error} fullWidth size="small">
                <TextField type="number" name="fortune_wheel.period" value={value.period / 60} onChange={onChangePeriod} size="small" />
                <FormHelperText> {t("ru.halls.wager.fortune_wheel.period")} </FormHelperText>
            </FormControl>
        </Grid>
        <Grid item xs={3} sm={12}>
            <FormControl error={error} fullWidth size="small">
                <TextField type="number" name="fortune_wheel.minDeposit" value={value.minDeposit} onChange={onChangeMinDeposit} size="small" />
                <FormHelperText> {t("ru.halls.wager.fortune_wheel.minDeposit")} </FormHelperText>
            </FormControl>
        </Grid>
        <Grid item xs={3} sm={12}>
            <FormControl error={error} fullWidth size="small">
                <TextField type="number" name="fortune_wheel.wager" value={value.wager} onChange={onChangeWager} size="small" />
                <FormHelperText> {t("ru.halls.wager.fortune_wheel.wager")} </FormHelperText>
            </FormControl>
        </Grid>
        <FortuneWheelTable sectors={value.sectors} setSectors={onChangeSectors} />
    </Container>;
};

export default FieldFortuneWheel;